// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ov40","index":"styles_index__8LpKS"};